/* ===========================================================
   Myoform — Depth of Testing
   Optional motion only: reveal cards as they enter view, and
   give the body-systems plate a soft scroll-linked tilt.
   Labels stay readable (no full spin of the labeled artwork).
   =========================================================== */

(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setUpReveals(root) {
    var targets = Array.prototype.slice.call(
      root.querySelectorAll('[data-mdt-reveal], [data-mdt-stagger], [data-mdt-body]')
    );
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.16 }
    );

    targets.forEach(function (target) {
      observer.observe(target);
    });
  }

  function setUpBodyDrift(root) {
    var body = root.querySelector('[data-mdt-spin]');
    if (!body) return;

    var card = body.closest('[data-mdt-card]') || body;
    var ticking = false;
    var isNarrow = window.matchMedia('(max-width: 749px)');

    function update() {
      ticking = false;

      var viewportHeight = window.innerHeight;
      var rect = card.getBoundingClientRect();

      if (rect.bottom < viewportHeight * -0.5 || rect.top > viewportHeight * 1.5) return;

      var travel = rect.height + viewportHeight;
      var progress = (viewportHeight - rect.top) / travel;

      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      // Slow counter-drift: the group floats as the card passes, which keeps
      // the callouts locked to the figure's leader lines.
      var amplitude = isNarrow.matches ? 8 : 16;
      var shift = (0.5 - progress) * 2 * amplitude;
      body.style.setProperty('--mdt-shift', shift.toFixed(2) + 'px');
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
    if (typeof isNarrow.addEventListener === 'function') {
      isNarrow.addEventListener('change', requestUpdate);
    }

    update();
  }

  function init(root) {
    if (!root || root.dataset.mdtReady === 'true') return;
    root.dataset.mdtReady = 'true';

    if (!('IntersectionObserver' in window)) return;
    if (prefersReducedMotion.matches) return;

    root.setAttribute('data-mdt-motion', 'true');
    setUpReveals(root);
    setUpBodyDrift(root);
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('[data-mdt]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
